import React, {Component} from 'react'
import withStyles from "@material-ui/core/es/styles/withStyles";
import PropTypes from 'prop-types';
import Button from "@material-ui/core/es/Button/Button";
import CardContent from "@material-ui/core/es/CardContent/CardContent";
import green from "@material-ui/core/es/colors/green";
import CardActions from "@material-ui/core/es/CardActions/CardActions";
import Card from "@material-ui/core/es/Card/Card";
import CircularProgress from "@material-ui/core/es/CircularProgress/CircularProgress";
import {withSnackbar} from 'notistack';
import RatingForm from "./forms/RatingForm";
import {saveRating} from "../services/PatientProgramService";

const ratings = [1, 2, 3, 4, 5];
const styles = theme => ({
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  dense: {
    marginTop: 19,
  },
  menu: {
    width: 200,
  },
  card: {
    borderRadius: 0
  },
  wrapper: {
    margin: theme.spacing.unit,
    position: 'relative',
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
});

/**
 * Mark dispatched form
 *
 * @return {*}
 * @constructor
 */
class RatingFormComponent extends Component {

  /**
   * Constructor
   *
   * @param props
   */
  constructor(props) {
    super(props);

    let rating = {rating: 0, rating_comments: ''};
    if (props.patient_program)
      rating = {rating: props.patient_program.rating, rating_comments: props.patient_program.rating_comments};

    this.state = {
      rating: rating
    };

    this.onModelChange = this.onModelChange.bind(this);
  }

  /**
   * On model field change
   *
   * @param model
   * @return {Function}
   */
  onModelChange = (model) => (field, value) => {
    this.setState({
      ...this.state,
      [model]: {
        ...this.state[model],
        [field]: value
      }
    });
  };

  /**
   * Update invoice
   */
  update = () => {
    let {handlePromise, patient_program} = this.props;
    let {rating} = this.state;
    handlePromise(saveRating(this.patient_program.id, rating));
  };

  render() {
    let {classes, close, isFetching, errors} = this.props;
    let {rating} = this.state;
    return (
      <Card className={classes.card} elevation={0}>
        <CardContent>
          <form className={classes.container} noValidate autoComplete="off">
            <RatingForm model={rating} onModelChange={this.onModelChange("rating")}
                        errors={errors}/>
          </form>
        </CardContent>
        <CardActions dir="rtl">
          <Button variant="outlined" color="secondary" onClick={close} disabled={isFetching}>
            Close
          </Button>
          <div className={classes.wrapper}>
            <Button variant="contained" color="primary" onClick={this.update} disabled={isFetching}>
              {isFetching ? "Saving" : "Save"}
            </Button>
            {isFetching && <CircularProgress size={24} className={classes.buttonProgress}/>}
          </div>
        </CardActions>
      </Card>
    );
  }
}


/**
 * Properties
 *
 * @type {{fetch: *}}
 */
RatingFormComponent.propTypes = {
  patient_program: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  successCallback: PropTypes.func.isRequired,
  failureCallback: PropTypes.func.isRequired
};

export default withSnackbar(withStyles(styles)(RatingFormComponent));